export default {
  


  /*loading状态*/
  getLoading(state){
    return state.isLoading
  }
}
